<template>
  <div>
    <div
      v-if="slots !== null && config !== null"
      class=""
    >
      <div
        v-for="(teeSlot, index) in slots"
        class="rounded-b-lg"
      >
        <SlotRow
          :tee-slot="teeSlot"
          :last-slot="index === (slots.length - 1)"
          :max-players="config.maxPlayers"
          :tee-time-to-book="teeTimeToBook"
          @book="bookSlot"
        />
      </div>
    </div>

    <div
      v-else
      class="mt-56 mb-32 ml-auto mr-auto text-center"
    >
      <LoadingSpinner />
    </div>
  </div>
</template>

<script>
import SlotRow from '@/app/shared/components/slots/slotRow.vue';
import LoadingSpinner from '@/app/shared/components/base/loading/loadingSpinner.vue';

export default {
  name: 'Slots',

  components: {
    SlotRow,
    LoadingSpinner,
  },

  props: {
    slots: {
      type: Array,
      default: null,
    },
    config: {
      type: Object,
      default: null,
    },
    teeTimeToBook: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {

    };
  },

  methods: {
    getWidth() {
      if (this.config !== null) {
        if (this.config.maxPlayers === 1) {
          return 'width: 90%;';
        }
        if (this.config.maxPlayers === 2) {
          return 'width: 45%;';
        }
        if (this.config.maxPlayers === 3) {
          return 'width: 33.33%;';
        }
        if (this.config.maxPlayers === 4) {
          return 'width: 22.5%;';
        }
      }
    },
    bookSlot(slot) {
      this.$emit('book', slot);
    },
  },
};
</script>
